import { render, staticRenderFns } from "./productDiscountTable.vue?vue&type=template&id=098059fb&"
import script from "./productDiscountTable.vue?vue&type=script&lang=js&"
export * from "./productDiscountTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports